import type { IconSvgObject } from './types';

const CloudIcon: IconSvgObject = [
  ["path", { d: "M17.4776 10.5001C17.485 10.5 17.4925 10.5 17.5 10.5C19.9853 10.5 22 12.5147 22 15C22 17.4853 19.9853 19.5 17.5 19.5H7C4.23858 19.5 2 17.2614 2 14.5C2 11.9003 3.98398 9.76407 6.52042 9.5227M17.4776 10.5001C17.4924 10.3354 17.5 10.1686 17.5 10C17.5 6.96243 15.0376 4.5 12 4.5C9.12324 4.5 6.76233 6.70862 6.52042 9.5227M17.4776 10.5001C17.3753 11.6345 16.9286 12.6696 16.2428 13.5M6.52042 9.5227C6.67826 9.50768 6.83823 9.5 7 9.5C8.12582 9.5 9.16474 9.87209 10.0005 10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CloudIcon;
